// import React, { useEffect, useState } from "react";
// import { formatDateInput } from "../../utils";
// const CustomDateRangePicker = ({dateMinMaxValue,setMinMaxDateValue,columnData,setColumnFilters,columnFilters,debouncedSetFilters,setDebouncedFilters,setDebounceDelay}) => {
// //   const [startDate, setStartDate] = useState("");
// //   const [endDate, setEndDate] = useState("");

// const handleDateChange = (e, type) => {
//   const formattedDate = formatDateInput(e.target.value);

//   setMinMaxDateValue(prevState => ({
//       ...prevState,
//       [type]: formattedDate
//   }));
// };

// // Usage:



//   // const handleStartDateChange = (e) => {
//   //   const formatedDate = formatDateInput(e.target.value)

//   //   setMinMaxDateValue({
//   //       ...dateMinMaxValue,
//   //       startDate: formatedDate, // Replace with the actual value
//   //     });
   
//   // };

//   // const handleEndDateChange = (e) => {
//   //   // setEndDate(e.target.value);
//   //   console.log(e.target.value,"jhs")
    
//   //     const formatedDate = formatDateInput(e.target.value)
//   //     console.log(formatedDate,"formaatedDate12")
//   //     setMinMaxDateValue({
//   //         ...dateMinMaxValue,
//   //         endDate: formatedDate, // Replace with the actual value
//   //       });
   
//   // };
//   // useEffect(() => {
//   //   if (dateMinMaxValue.startDate && dateMinMaxValue.startDate !== "") {
//   //     // Format start date
//   //     const formattedDateMin = new Date(dateMinMaxValue.startDate).toLocaleDateString("en-US", {
//   //       month: "2-digit",
//   //       day: "2-digit",
//   //       year: "numeric"
//   //     });
       
//   //     // Update column filters
//   //     setColumnFilters({
//   //       ...columnFilters,
//   //       [columnData.queryParam]: formattedDateMin,
//   //     });
//   //     setDebounceDelay(2500)
//   //     // Apply debounced filter update
//   //     debouncedSetFilters({
//   //       ...columnFilters,
//   //       [columnData.queryParam]: formattedDateMin,
//   //     });
//   //   }
  
//   //   if (dateMinMaxValue.endDate && dateMinMaxValue.endDate !== "") {
//   //     // Format end date
//   //     const formattedDateMax = new Date(dateMinMaxValue.endDate).toLocaleDateString("en-US", {
//   //       month: "2-digit",
//   //       day: "2-digit",
//   //       year: "numeric"
//   //     });
  
  
//   //     // Update column filters
//   //     setColumnFilters({
//   //       ...columnFilters,
//   //       [columnData.queryParam1]: formattedDateMax,
//   //     });
//   //     setDebounceDelay(6000)
//   //     debouncedSetFilters({
//   //       ...columnFilters,
//   //       [columnData.queryParam1]: formattedDateMax,
//   //     });
//   //   }
//   // }, [dateMinMaxValue]);
  
//   // const handleInput = (e, field) => {
//   //   if (e.target.value === "") {
//   //     // Add any function you want to trigger here
//   //     setColumnFilters({
//   //       ...columnFilters,
//   //       starting_date_min: null, 
//   //       starting_date_max :null
//   //     })
//   //     setDebouncedFilters({})
//   //   }
//   // };

// //   const handleDateChange = (e, field) => {
// //     let value = e.target.value;

// //     // Allow only valid characters (digits and "-")
// //     if (!/^[\d-]*$/.test(value)) return;

// //     // Automatically format input (prevents incorrect formatting)
// //     if (value.length === 2 || value.length === 5) {
// //       value += "-";
// //     }

// //     // Update state only if value is in correct format
// //     if (field === "Start Date") {
// //       setDateMinMaxValue((prev) => ({ ...prev, startDate: value }));
// //     } else {
// //       setDateMinMaxValue((prev) => ({ ...prev, endDate: value }));
// //     }
// //   };


// useEffect(() => {
//   const { startDate, endDate } = dateMinMaxValue;
// console.log(dateMinMaxValue,"dateMinMaxValue")
//   // If both dates exist, trigger the API call only once with both values
//   if (startDate && endDate) {
//     // const formattedDateMin = startDate ? new Date(startDate).toLocaleDateString("en-US", {
//     //   month: "2-digit",
//     //   day: "2-digit",
//     //   year: "numeric"
//     // }) : null;

//     // const formattedDateMax = endDate ? new Date(endDate).toLocaleDateString("en-US", {
//     //   month: "2-digit",
//     //   day: "2-digit",
//     //   year: "numeric"
//     // }) : null;
// // console.log(formattedDateMax,"formattedDateMax")
//     // Update column filters with both start and end date
//     setColumnFilters(prevFilters => ({
//       ...prevFilters,
//       [columnData.queryParam]: startDate,
//       [columnData.queryParam1]: endDate
//     }));

//     // setDebounceDelay(2500); // Unified debounce time for both dates
//     debouncedSetFilters(prevFilters => ({
//       ...prevFilters,
//       [columnData.queryParam]: startDate,
//       [columnData.queryParam1]: endDate
//     }));

//     return; // Prevent further execution
//   }

//   // If only start date exists, trigger API call
//   if (startDate) {
//     // const formattedDateMin = new Date(startDate).toLocaleDateString("en-US", {
//     //   month: "2-digit",
//     //   day: "2-digit",
//     //   year: "numeric"
//     // });

//     setColumnFilters(prevFilters => ({
//       ...prevFilters,
//       [columnData.queryParam]: startDate
//     }));

//     // setDebounceDelay(2500);
//     debouncedSetFilters(prevFilters => ({
//       ...prevFilters,
//       [columnData.queryParam]: startDate
//     }));
//   }

//   // If only end date exists, trigger API call
//   if (endDate) {
//     // const formattedDateMax = new Date(endDate).toLocaleDateString("en-US", {
//     //   month: "2-digit",
//     //   day: "2-digit",
//     //   year: "numeric"
//     // });
// console.log(endDate,"endDate")
//     setColumnFilters(prevFilters => ({
//       ...prevFilters,
//       [columnData.queryParam1]: endDate
//     }));

//     // setDebounceDelay(2500);
//     debouncedSetFilters(prevFilters => ({
//       ...prevFilters,
//       [columnData.queryParam1]: endDate
//     }));
//   }
// }, [dateMinMaxValue]);

//   return (
   
//     // <div
//     //   style={{
//     //     display: "flex",
//     //     flexDirection: "row",
//     //     gap: "16px",
//     //     alignItems: "center",
//     //     marginTop:"9px"
//     //   }}
//     // >
//     //   <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
//     //   {/* <h4 style={{ fontSize: "1.25rem", fontWeight: "600" }}>Start date</h4> */}
//     //   {/* <h6>Min</h6> */}
//     //     <input
//     //       type="date"
//     //       id="start-date"
//     //     //   placeholder="Start Date"
//     //       value={dateMinMaxValue.startDate ? dateMinMaxValue.startDate : ""}
//     //       onInput={(e) => handleInput(e, "Start Date")}
//     //       onChange={handleStartDateChange}
       
//     //       style={{
//     //         padding: "6px",
//     //         border: "1px solid #ccc",
//     //         borderRadius: "8px",
//     //         boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
//     //         outline: "none",
//     //         transition: "box-shadow 0.2s",
//     //       }}
//     //     />
//     //   </div>

//     //   <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
//     //   {/* <h4 style={{ fontSize: "1.25rem", fontWeight: "600" }}>End date</h4> */}
//     //     <input
//     //       type="date"
//     //     //   placeholder="End Date"
//     //       id="end-date"
//     //       value={dateMinMaxValue.endDate ? dateMinMaxValue.endDate : ""}
//     //       onInput={(e) => handleInput(e, "End Date")}
//     //       onChange={handleEndDateChange}
//     //       min={dateMinMaxValue.startDate ? dateMinMaxValue.startDate : ""}
//     //       style={{
//     //         padding: "8px",
//     //         border: "1px solid #ccc",
//     //         borderRadius: "8px",
//     //         boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
//     //         outline: "none",
//     //         transition: "box-shadow 0.2s",
//     //       }}
//     //     />
//     //   </div>
//     // </div>

//     <div
//     style={{
//       display: "flex",
//       flexDirection: "row",
//       gap: "16px",
//       alignItems: "center",
//       marginTop: "9px",
//     }}
//   >
//     <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
//       <input
//         type="text"
//         id="start-date"
//         placeholder="Min Date MM/DD/YYYY"
//         value={dateMinMaxValue.startDate ? dateMinMaxValue.startDate : null}
//         onChange={(e) => handleDateChange(e, "startDate")}
//         style={{
//           padding: "6px",
//           border: "1px solid #ccc",
//           borderRadius: "8px",
//           boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
//           outline: "none",
//           transition: "box-shadow 0.2s",
//         }}
//       />
//     </div>

//     <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
//       <input
//         type="text"
//         id="end-date"
//         placeholder="Max Date MM/DD/YYYY"
//         value={dateMinMaxValue.endDate ?dateMinMaxValue.endDate : null}
//         onChange={(e) =>  handleDateChange(e, "endDate")}
//         style={{
//           padding: "8px",
//           border: "1px solid #ccc",
//           borderRadius: "8px",
//           boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
//           outline: "none",
//           transition: "box-shadow 0.2s",
//         }}
//       />
//     </div>
//   </div>


//   );
// };

// export default CustomDateRangePicker;



import React, { useEffect } from "react";
import { formatDateInput } from "../../utils";

const CustomDateRangePicker = ({
  dateMinMaxValue,
  setMinMaxDateValue,
  columnData,
  setColumnFilters,
  columnFilters,
  debouncedSetFilters,
  setFilterErrorMsg,
  filterErrorMsg
}) => {



  function isValidDate(dateStr) {
    const regex = /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/;

    if (!regex.test(dateStr)) {
      setFilterErrorMsg("Invalid format. Use MM/DD/YYYY.");
      return false;
    }

    const [month, day, year] = dateStr.split('/').map(Number);
    const date = new Date(year, month - 1, day);

    if (
      date.getFullYear() !== year ||
      date.getMonth() !== month - 1 ||
      date.getDate() !== day
    ) {
      setFilterErrorMsg("Invalid date. Please enter a real date.");
      return false;
    }

    setFilterErrorMsg(""); // Clear error message if valid
    return true;
  }




  // Common function to handle date input changes
  const handleDateChange = (e, type) => {
    const formattedDate = formatDateInput(e.target.value);

    setMinMaxDateValue(prevState => ({
      ...prevState,
      [type]: formattedDate || null, // Set to null if empty to avoid "0"
    }));
  };

  // useEffect(() => {
  //   const { startDate, endDate } = dateMinMaxValue;
  

  //   if (!startDate && !endDate) {
  //     // setColumnFilters(prevFilters => {
  //     //   const updatedFilters = { ...prevFilters };
  //     //   delete updatedFilters[columnData.queryParam];
  //     //   delete updatedFilters[columnData.queryParam1];
  //     //   return updatedFilters;
  //     // });
  
  //     debouncedSetFilters(prevFilters => {
  //       const updatedFilters = { ...prevFilters };
  //       delete updatedFilters[columnData.queryParam];
  //       delete updatedFilters[columnData.queryParam1];
  //       return updatedFilters;
  //     });
  
  //     return; // Early exit to prevent further API call triggers
  //   }
  

  //   setColumnFilters(prevFilters => {
  //     const updatedFilters = { ...prevFilters };
  
  //     // Ensure "0" is not sent as a valid filter
  //     if (startDate && startDate !== "0") {
  //       updatedFilters[columnData.queryParam] = startDate;
  //     } else {
  //       delete updatedFilters[columnData.queryParam]; // Remove if "0" or empty
  //     }
  
  //     if (endDate && endDate !== "0") {
  //       updatedFilters[columnData.queryParam1] = endDate;
  //     } else {
  //       delete updatedFilters[columnData.queryParam1]; // Remove if "0" or empty
  //     }
  
  //     console.log(updatedFilters, "Updated Filters");
  //     return updatedFilters;
  //   });
  
  //   debouncedSetFilters(prevFilters => {
  //     const updatedFilters = { ...prevFilters };
  
  //     if (startDate && startDate !== "0") {
  //       updatedFilters[columnData.queryParam] = startDate;
  //     } else {
  //       delete updatedFilters[columnData.queryParam];
  //     }
  
  //     if (endDate && endDate !== "0") {
  //       updatedFilters[columnData.queryParam1] = endDate;
  //     } else {
  //       delete updatedFilters[columnData.queryParam1];
  //     }
  
  //     console.log(updatedFilters, "Updated Filters for Debounced");
  //     return updatedFilters;
  //   });
  
  // }, [dateMinMaxValue]); // Ensure this useEffect only runs when dateMinMaxValue changes
//   useEffect(() => {
//           if (dateMinMaxValue.startDate && dateMinMaxValue.startDate !== null && isValidDate(dateMinMaxValue.startDate)) {
//             console.log(dateMinMaxValue.startDate,"khaja")
//             // Format start date
//             // const formattedDateMin = new Date(dateMinMaxValue.startDate).toLocaleDateString("en-US", {
//             //   month: "2-digit",
//             //   day: "2-digit",
//             //   year: "numeric"
//             // });
           
//             // Update column filters
//             setColumnFilters({
//               ...columnFilters,
//               [columnData.queryParam]: dateMinMaxValue.startDate,
//             });
//             // Apply debounced filter update
//             debouncedSetFilters({
//               ...columnFilters,
//               [columnData.queryParam]: dateMinMaxValue.startDate,
//             });
//           }
      
//           if (dateMinMaxValue.endDate && dateMinMaxValue.endDate !== null && isValidDate(dateMinMaxValue.endDate)) {
//             console.log(dateMinMaxValue.endDate,"bilal")
            
//             // Format end date
//             // const formattedDateMax = new Date(dateMinMaxValue.endDate).toLocaleDateString("en-US", {
//             //   month: "2-digit",
//             //   day: "2-digit",
//             //   year: "numeric"
//             // });
//             // console.log(endDate,"endDate")
//      setColumnFilters(prevFilters => ({
//        ...prevFilters,
//        [columnData.queryParam1]:dateMinMaxValue.endDate,
//      }));
//      debouncedSetFilters(prevFilters => ({
//        ...prevFilters,
//        [columnData.queryParam1]: dateMinMaxValue.endDate
//      }));
//    }
//  }, [dateMinMaxValue]);
useEffect(()=>{
  if (!dateMinMaxValue.startDate && !dateMinMaxValue.endDate) {
    setFilterErrorMsg("")
}
},[filterErrorMsg,dateMinMaxValue])

useEffect(() => {
  let updatedFilters = { ...columnFilters };

  // Handle start date
  if (dateMinMaxValue.startDate && isValidDate(dateMinMaxValue.startDate)) {
    updatedFilters[columnData.queryParam] = dateMinMaxValue.startDate;
  } else {
    delete updatedFilters[columnData.queryParam]; // Remove if invalid
  }

  // Handle end date
  if (dateMinMaxValue.endDate && isValidDate(dateMinMaxValue.endDate)) {
    updatedFilters[columnData.queryParam1] = dateMinMaxValue.endDate;
  } else {
    delete updatedFilters[columnData.queryParam1]; // Remove if invalid
  }
  // Set filters once to avoid multiple API calls
  setColumnFilters(updatedFilters);
  debouncedSetFilters(updatedFilters);
}, [dateMinMaxValue]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        gap: "16px",
        alignItems: "center",
        marginTop: "9px",
      }}
    >
      {/* Start Date Input */}
      <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
        <input
          type="text"
          id="start-date"
          placeholder="Min Date MM/DD/YYYY"
          value={dateMinMaxValue.startDate || ""}
          onChange={(e) => handleDateChange(e, "startDate")}
          style={inputStyle}
        />
      </div>

      {/* End Date Input */}
      <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
        <input
          type="text"
          id="end-date"
          placeholder="Max Date MM/DD/YYYY"
          value={dateMinMaxValue.endDate || ""}
          onChange={(e) => handleDateChange(e, "endDate")}
          style={inputStyle}
        />
      </div>
    </div>
  );
};

// Common style for inputs
const inputStyle = {
  padding: "8px",
  border: "1px solid #ccc",
  borderRadius: "8px",
  boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
  outline: "none",
  transition: "box-shadow 0.2s",
};

export default CustomDateRangePicker;
